<template>
  <modal v-model="model" max-width="920">
    <template #title>Select Your Review Type</template>
    <template #content>
      <v-item-group
        v-model="selectedReviewType"
        class="review-type-card-grid"
      >
        <v-item
          v-for="(reviewType, reviewTypeIdx) in reviewTypeInfo"
          v-slot="{ toggle }"
          :key="reviewTypeIdx"
          :value="reviewType.value"
        >
          <review-type-card
            :review-title="reviewType.title"
            :description="reviewType.description"
            :timeframe="reviewType.timeframe"
            :num-reviewers="reviewType.numReviewers"
            :selected="reviewType.value === selectedReviewType"
            @click="toggle"
          />
        </v-item>
      </v-item-group>
    </template>
    <template #actions>
      <action-button class="mr-3" @click="model = false">
        Close
      </action-button>
      <action-button
        color="primary"
        class="mr-3"
        @click="saveReviewType"
      >
        Confirm
      </action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';
import { Review } from '@/models';
import { reviewTypeToInfoMapping } from '@/modules/reviewTypeMappings';
import ReviewTypeCard from '@/components/ReviewSettingsPage/ReviewTypeCard';

export default {
  name: 'ReviewTypeDialog',
  components: {
    ActionButton,
    Modal,
    ReviewTypeCard,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    review: {
      type: Review,
      required: true,
    },
  },
  data: () => ({ selectedReviewType: null }),
  computed: {
    model: {
      get: function () {
        return this.open;
      },
      set: function (value) {
        this.$emit('update:open', value);
      },
    },
    reviewTypeInfo() {
      return Object.keys(reviewTypeToInfoMapping).map(
        (reviewType) => ({
          ...reviewTypeToInfoMapping[reviewType],
          value: reviewType,
        })
      );
    },
  },
  watch: {
    open: function (open) {
      // Reset the selected type each time the modal is opened.
      if (open) {
        this.selectedReviewType = this.review.reviewType;
      }
    },
  },
  mounted() {
    this.selectedReviewType = this.review.reviewType;
  },
  methods: {
    saveReviewType() {
      this.$emit('update-review-type', this.selectedReviewType);
      this.model = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-body {
  line-height: 150% !important;
}
.review-type-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}
</style>
